import baseFetch from '../baseFetch';

export const fetchWindWave = async (lat, lon, bwWindWaveModel, grb, userDetails = {}) =>
  baseFetch(`forecasts/legacy?lat=${lat}&lon=${lon}&model=${bwWindWaveModel}&grb=${grb}`, userDetails);

export const fetchForecasts = async (lat, lon, interval, userDetails = {}) =>
  baseFetch(`forecasts?lat=${lat}&lon=${lon}&interval=${interval}`, userDetails);

export const fetchWrittenForecasts = async (lat, lon, userDetails = {}) =>
  baseFetch(`forecasts/written?lat=${lat}&lon=${lon}`, userDetails);



// WEBPACK FOOTER //
// ./src/common/api/forecast.js